/** Tracking is stateful; keep proxies inside the calculation that owns their log. */
export function createRecordReadLog() {
    return { reads: new Map(), enumerated: false };
}
export function trackRecordReads(record, log) {
    return new Proxy(record, {
        get(target, key, receiver) {
            const value = Reflect.get(target, key, receiver);
            log.reads.set(key, value);
            return value;
        },
        has(target, key) {
            log.reads.set(key, Reflect.get(target, key));
            return Reflect.has(target, key);
        },
        getOwnPropertyDescriptor(target, key) {
            log.reads.set(key, Reflect.get(target, key));
            return Reflect.getOwnPropertyDescriptor(target, key);
        },
        ownKeys(target) {
            log.enumerated = true;
            return Reflect.ownKeys(target);
        },
    });
}
